import React from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import '@ya.praktikum/react-developer-burger-ui-components';
import styles from './ingredient-element.module.css';
import { ingredientType, TIngredientType } from '../../utils/types';

function IngredientElement(props: {
    item: TIngredientType;
    number?: number | null;
}): JSX.Element {
    const { item, number } = props;
    return (
        item && (
            <div className={styles.feed_imageback} key={uuid()}>
                <div className={styles.feed_image}>
                    <img
                        src={item.image_mobile}
                        alt={item.name}
                        className={
                            number ? styles.feed_image_plus : styles.feed_img
                        }
                    />
                    {number && (
                        <div className={styles.feed_plus}>+{number}</div>
                    )}
                </div>

                {false && (
                    <div
                        style={{
                            opacity: 0.9,
                        }}
                        className={styles.feed_image}
                    />
                )}
            </div>
        )
    );
}
IngredientElement.propTypes = {
    item: ingredientType,
    number: PropTypes.number,
};
IngredientElement.defaultProps = {
    item: null,
    number: null,
};

export default IngredientElement;
